import { render, staticRenderFns } from "./resetPassWord.vue?vue&type=template&id=95da5ffa&scoped=true"
import script from "./resetPassWord.vue?vue&type=script&lang=js"
export * from "./resetPassWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95da5ffa",
  null
  
)

export default component.exports